(function($) {

$.fn.heroSlideShow = function( options ) {
	return this.each(function() {
		
		var settings = $.extend({
				timer: 7500,
				activeClass: 'active',
			}, options, $(this).data() ),
			
			$container = $(this),
			$slidesWrap = $container.children('.wp-block-metropolis-hero__slides'),
			$slides = $slidesWrap.children(),
			$nav = $container.children('nav'),
			$pagination = $nav.children('.pagination'),
			$next = $nav.children('.next'),
			$nextImage = $nav.find('.image-wrap'),
			$nextTitle = $nav.find('h4'),
			$progress = $nav.find('.timer-wrap'),
			$progressBar = $progress.children('.timer'),
			length = $slides.length,
			index = 0,
			percentTime,
    		tick,
    		time = 0;
			
		function startProgressbar() {
        	resetProgressbar();
        	percentTime = 0;
        	tick = setInterval(interval, 10);
    	}
		
		function interval() {
        	percentTime += 1 / (time + ( settings.timer / 1000 ));
        	$progressBar.css({
            	width: percentTime + "%"
        	});
        	if (percentTime >= 100) {
            	nextSlide();
            	startProgressbar();
        	}
    	}
	
    	function resetProgressbar() {
        	$progressBar.css({
            	width: 0 + '%'
        	});
        	clearInterval(tick);
    	}
		
		function removeProgressbar() {
        	$progress.remove();
        	clearInterval(tick);
    	}
		
    	startProgressbar();
			
		function slideTo(idx) {
							
			$slides
				.removeClass( settings.activeClass )
				.eq(idx)
				.queue(function(next){
					$(this).addClass( settings.activeClass );
					next();
				});
				
			$pagination
				.children()
				.removeClass( settings.activeClass )
				.eq(idx)
				.queue(function(next){
					$(this).addClass( settings.activeClass );
					next();
				});
				
			const nextIdx = idx + 1 < length ? idx + 1 : 0;
			const $nextSlide = $slides.eq(nextIdx);
			const $nextHeading = $nextSlide.find('h1');
			const image = $nextSlide.children('.wp-block-metropolis-section__background').css('background-image');
			
			
			$nextTitle.html( $nextHeading.html() );
			
			if( image !== 'none' ) {
				const imageUrl = image.replace('url(','').replace(')','').replace(/\"/gi, "");
				$nextImage.html('<img src="' + imageUrl + '">').removeClass('hidden');
			} else {
				$nextImage.addClass('hidden');
			}
				
			index = idx;
		}
			
		function nextSlide() {
			var nextIdx = index + 1 < length ? index + 1 : 0;
			slideTo(nextIdx);
		}
		
		function resizeContainer() {
		    var tallest = 0;
			var padding = 0;
		    $slides.each(function() {
			    thisHeight = jQuery(this).children('.wp-block-metropolis-section__container').height();
			    if(thisHeight > tallest) tallest = thisHeight;
		    });
			if( Modernizr.mq('only screen and (max-width: 767px)') ) {
				padding = 80;
			} else if( Modernizr.mq('only screen and (max-width: 999px)') ) {
				padding = 200;
			} else {
				padding = 220;
			}
			
		    $slidesWrap.height( tallest + padding );
	    }
	    
		resizeContainer(index);
		slideTo(index);
		
		$(window).resize(function() {
		    resizeContainer();
	    });
		
		$pagination.on( 'click', 'span', function() {
			var idx = $(this).index();
			slideTo(idx);
			removeProgressbar();
		} );
		
		$next.on( 'click', function() {
			nextSlide();
			removeProgressbar();
		} );
		
	});
};

$(function() {
	
	const $hero = $('.wp-block-metropolis-hero');
	
	$hero.each( function() {
		
		const $slides = $(this).children('.wp-block-metropolis-hero__slides').children();
		const $nav = $(this).children('nav');
		
		$slides.each( function() {
			$nav.children('.pagination').append('<span></span>');
		} ).promise().done( function() { 
			$('.wp-block-metropolis-hero').heroSlideShow();
		} );
			
	} );
	
});

})(jQuery);